// import Alpine from "alpinejs";

// Alpine.start();

console.log("gemeinsam.js loaded");